import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { routes } from '@/shared/config/routes'
import { LoginPage } from '@/pages/login'
import { TasksPage } from '@/pages/tasks'
import { TransferPage } from '@/pages/transfer'
import { SystemPage } from '@/pages/system'
import { AppLayout } from '../AppLayout'
import { useAuthStore } from '../store/authStore'
import { useSystemStore } from '../store/systemStore'

export const AppRouter: React.FC = () => {
  const { isAuthenticated } = useAuthStore()
  const { selectedSystem } = useSystemStore()

  return (
    <BrowserRouter>
      <Routes>
        <Route path={routes.login} element={<LoginPage />} />
        <Route
          path={routes.system}
          element={
            isAuthenticated ? (
              <SystemPage />
            ) : (
              <Navigate to={routes.login} replace />
            )
          }
        />
        <Route element={<AppLayout />}>
          <Route
            path={routes.tasks}
            element={
              isAuthenticated && selectedSystem ? (
                <TasksPage />
              ) : isAuthenticated ? (
                <Navigate to={routes.system} replace />
              ) : (
                <Navigate to={routes.login} replace />
              )
            }
          />

          <Route
            path={routes.transfer}
            element={
              isAuthenticated && selectedSystem ? (
                <TransferPage />
              ) : isAuthenticated ? (
                <Navigate to={routes.system} replace />
              ) : (
                <Navigate to={routes.login} replace />
              )
            }
          />

          <Route
            path="/"
            element={
              <Navigate
                to={isAuthenticated ? routes.system : routes.login}
                replace
              />
            }
          />
          <Route
            path="*"
            element={
              <Navigate
                to={isAuthenticated ? routes.system : routes.login}
                replace
              />
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
